import { CommentEmptyCloud as CommentEmptyCloud_kojaro } from './CommentEmptyCloud.kojaro';
import { CommentEmptyCloud as CommentEmptyCloud_phosphor } from './CommentEmptyCloud.phosphor';
import { CommentEmptyCloud as CommentEmptyCloud_zoomg } from './CommentEmptyCloud.zoomg';
import { CommentEmptyCloud as CommentEmptyCloud_zoomit } from './CommentEmptyCloud.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return CommentEmptyCloud_kojaro;

    case 'zoomg':
      return CommentEmptyCloud_zoomg;

    case 'phosphor':
      return CommentEmptyCloud_phosphor;

    default:
      return CommentEmptyCloud_zoomit;
  }
};

export const CommentEmptyCloud = IconRenderer();
